import {
  getBinaryTargetForCurrentPlatform,
  getNodeAPIName,
} from "@prisma/internals";

export type PrismaEngine = "query-engine";
export type PrismaEngineType = "binary" | "library";

/**
 * Returns the expected name of a Prisma binary
 */
export async function prismaEngineName(
  engine: PrismaEngine,
  type: PrismaEngineType
): Promise<string> {
  const binaryTarget = await getBinaryTargetForCurrentPlatform();
  const extension = binaryTarget === "windows" ? ".exe" : "";

  if (type === "library") {
    return getNodeAPIName(binaryTarget, "fs");
  } else if (type === "binary") {
    return `${engine}-${binaryTarget}${extension}`;
  } else {
    throw new Error(`Unknown engine type: ${type}`);
  }
}
